import { render, staticRenderFns } from "./leftTop4.vue?vue&type=template&id=17e522b8&scoped=true"
import script from "./leftTop4.vue?vue&type=script&lang=js"
export * from "./leftTop4.vue?vue&type=script&lang=js"
import style0 from "./leftTop4.vue?vue&type=style&index=0&id=17e522b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e522b8",
  null
  
)

export default component.exports